import BaseModel from '@core/model';

import RestrictedPanelApi from '@packages/restricted-panels/api';

export class RestrictedPanel extends BaseModel {
    static name = 'RestrictedPanel';
    static entity = 'restrictedPanels';
    static Api = RestrictedPanelApi;

    static fields() {
        return {
            name: this.string(null).nullable(),
            offers: this.attr([])
        };
    }

    static is_valid() {
        return this.name && this.offers && this.offers.length > 0;
    }
}

export default RestrictedPanel;
